<template>
	<div class="" style="z-index: 999">
        <template v-for="item in properties">
            <FilterItem v-if="item.id !== 'detailed-filter'" :item="item" :value="filterValues[item.id]" @input="setFilterValue"/>
            <template v-else>
                <!-- reset for desktop -->
                <span class="d-none d-lg-block d-xl-inline mt-lg-3">
                    <button @click="resetFilter" class="slim-button reset-button"><span class="custom-close"></span> {{ $tr.product.filter.reset }}</button>
                </span>
                <span class="detailed-filter-wrapper">
                    <!-- reset for mobiles -->
                    <button @click="resetFilter" class="slim-button reset-button d-lg-none"><span class="custom-close"></span> {{ $tr.product.filter.reset }}</button>
                    <DetailedFilter :item="item" :values="filterValues" @input="setFilterValue"/>
                </span>
            </template>
        </template>
        <div class="d-block d-lg-none">
            <Button @click="applyCachedFilter" type="black">
                {{ $tr.product.filter.apply }}
            </Button>
        </div>
	</div>
</template>

<script>
	import FilterItem from "./Filter/FilterItem";
	import DetailedFilter from "./Filter/DetailedFilter";
	import Button from "../common/Button";

	export default {
		name: "FilterWrapper",
		components: {
			FilterItem,
			DetailedFilter,
            Button
		},
		props: [
			"properties"
		],
        data() {
		    return {
		        filterValues: {}
            };
        },
		methods: {
			setFilterValue(key, value) {
			    // Store filter to cache to be applied later
                if (!value)
                    this.$delete(this.filterValues, key);
                else
			        this.$set(this.filterValues, key, value);

			    // Desktop - apply filter right away
			    if (!this.$grid.isMobile())
				    this.$emit("input", key, value);
			},
			resetFilter() {
				this.$emit("input", null);
				this.filterValues = {};
			},
            applyCachedFilter() {
			    this.$emit("input", null);

			    // Apply each cached value
			    for (let key in this.filterValues)
			        this.$emit("input", key, this.filterValues[key]);

			    this.$emit("closeFiltersModal");
            }
		},
        created() {
		    this.$grid.deviceChange(isMobile => {
		        // Device changed from mobile to desktop -> apply selected filters
		        if (!isMobile)
		            this.applyCachedFilter();
            });
        }
	}
</script>
